import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/DairyGold.png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";


const DairyGold = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );
  const tableData = [
    {
      nutrient: "Protein",
      value: "17 - 18%",
      comment:
        "Supports consistent milk production and maintains muscle health.",
    },
    {
      nutrient: "Fat",
      value: "2%",
      comment: "Provides a balanced energy source for lactating cows.",
    },
    {
      nutrient: "Fiber",
      value: "11 - 13%",
      comment: "Improves digestion and supports gut health.",
    },
    {
      nutrient: "Moisture",
      value: "11 - 12%",
      comment: "Maintains feed freshness and enhances palatability.",
    },
    {
      nutrient: "Insoluble Matter",
      value: "Max 3%",
      comment: "Ensures feed purity and digestibility.",
    },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div className={isMobile ? "product-image product-image--mobile" : "product-image"}>
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">
              DAIRY GOLD{" "}
              <div>
                <span
                  style={{
                    fontFamily: "Playfair Display",
                    fontStyle: "italic",
                    color: "#ffc40c",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  <div>
                    <span
                      style={{
                        fontFamily: "Playfair Display",
                        fontStyle: "italic",
                        color: "#ffc40c",
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                    >
                      IT HAS 2 SUB PRODUCTS- SHAKTI GOLD, DAIRY GOLD
                    </span>
                  </div>{" "}
                </span>
              </div>{" "}
            </div>

            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p className="bold-description-line">
                <b>
                  Dairy Gold – Balanced Nutrition for Dairy Cows Producing 8 to
                  12 Liters of Milk.
                </b>
              </p>
              <p>
                Dairy Gold (TYPE - 3) is a carefully formulated cattle feed
                designed to support dairy cows producing between 8 to 12 liters
                of milk daily.
              </p>
              <p>
                With a well-balanced blend of protein, fat, fiber, and essential
                nutrients, Dairy Gold provides the nutrition needed to maintain
                steady milk production while promoting overall health and
                vitality in your herd.
              </p>
              <p>
                Made with high-quality ingredients like guar, rice bran,
                molasses, grains, mustard de-oiled cakes, and essential vitamins
                and minerals, Dairy Gold ensures that your cows receive all the
                nutrients they need to thrive.
              </p>
              <p>
                Dairy Gold is the ideal feed for farmers looking to optimize the
                health and productivity of their moderate milk-yielding cows. It
                offers balanced nutrition that supports steady milk production,
                better digestion, and long-term health.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <div className="benefits">
              <ul>
                <li className="benefit">
                  <div>
                    <b>Supports Moderate Milk Yield: </b> Dairy Gold's 17-18%
                    protein content is designed to meet the nutritional needs of
                    cows producing 8 to 12 liters of milk daily, helping them
                    maintain steady production levels.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Improved Digestive Function: </b>The fiber content
                    (11-13%) promotes healthy digestion, ensuring better
                    nutrient absorption and gut health, which is essential for
                    maintaining productivity and overall well-being in dairy
                    cattle.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Balanced Energy Levels: </b>The inclusion of 2% fat
                    provides a steady source of energy, keeping cows active and
                    productive without causing digestive strain.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Freshness and Palatability: </b>With an 11% moisture
                    content, Gaushala Gold stays fresh, ensuring that your
                    cattle consistently consume the required nutrients with
                    every feed.
                  </div>
                </li>

                <li className="benefit">
                  <div>
                    <b>Optimal Freshness & Taste: </b>With a moisture content of
                    11-12%, Dairy Gold remains fresh and palatable, ensuring
                    consistent consumption and preventing feed wastage.
                  </div>
                </li>
                <li className="benefit">
                  <div>
                    <b>Comprehensive Nutrition: </b>
                    Dairy Gold is packed with essential vitamins and minerals,
                    providing complete nutritional support for your dairy cows,
                    which helps improve immunity, overall health, and
                    reproductive performance.
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <NutritionalTable isCommentPresent={true} data={tableData} />
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Dairy-gold-pellets" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default DairyGold;
